/**
 * Care Plan Configuration Type
 */
export enum CarePlanConfigurationType {
  /**
   * A piece of text.
   */
  String = 'string',

  /**
   * A decimal number.
   */
  Number = 'number',

  /**
   * An integer number.
   */
  Integer = 'integer',

  /**
   * A boolean value: true or false.
   */
  Boolean = 'boolean',

  /**
   * A list of values.
   */
  Array = 'array',

  /**
   * Renders onto the layout an empty space.
   */
  EmptySpace = 'empty-space',

  /**
   * An UTC time value
   */
  Time = 'time',

  /**
   * An UTC date value
   */
  Date = 'date',

  /**
   * Configurations for creating an activities group entry based schedule.
   */
  ActivitiesGroupSchedule = 'activities-group-schedule',

  /**
   * Configurations for creating an activity type entry based schedule.
   */
  ActivityTypeSchedule = 'activity-type-schedule',

  /**
   * A schedule expression in the format of stringified PosologySchedule object.
   */
  PosologySchedule = 'posology-schedule',

  /**
   * Renders a configuration autocomplete field.
   */
  Autocomplete = 'autocomplete',
}
